import { useNavigate, useLocation } from 'react-router'

type NavigateOptions = {
  replace?: boolean
  state?: unknown
  removeKeys?: string[]
}

const usePersistedNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const navigateWithPreservedParams = (path: string, options?: NavigateOptions) => {
    // Get current URL parameters
    const currentParams = new URLSearchParams(location.search)
    // Split the new path into base path and query string
    const [basePath, newQueryString] = path.split('?')
    // Parse new query parameters if any
    const newParams = new URLSearchParams(newQueryString || '') 

    // Merge current parameters with new parameters
    currentParams.forEach((value, key) => {
      if (!newParams.has(key)) {
        newParams.set(key, value)
      }
    })

    // Remove specific keys if requested
    if (options?.removeKeys?.length) {
      options.removeKeys.forEach(key => newParams.delete(key))
    }

    // Construct the new path with merged parameters
    const queryString = newParams.toString()
    const newPath = queryString ? `${basePath}?${queryString}` : basePath
    
    // Scroll to top before navigation
    window.scrollTo({ top: 0, behavior: 'smooth' })
    
    navigate(newPath, { replace: options?.replace, state: options?.state })
  }

  return navigateWithPreservedParams
}

export default usePersistedNavigation
